export const CrudAction = {
  VIEW: 'view',
  CHANGE: 'change',
  ADD: 'add',
  DELETE: 'delete'
};
